import errorHandlers from '@/services/error-handlers';
import findClosestLocations from '@/helpers/find-closest-locations';
import http from '@/services/http';
import moment from 'moment-timezone';
import pickupTimes from '@/services/pickup-times';



const delivery = {
  async getClosestDeliveryLocation({ address }) {
    try {
      const locationData = await findClosestLocations({
        address,
        attributes: ['Delivery', 'WebOrdering'],
        distance: 25
      });

      return locationData;
    }

    catch (error) {
      throw error;
    }
  },

  async getEstimate(options) {
    try {
      const { address, location, merchant, order, addressGeocodeData, menuType } = options;

      const body = {
        storeId: location.storeId,
        orderValue: order.orderItemTotal || 20,
        deliveryService: merchant.deliveryService,
        dropOffAddress: {
          city: address.city,
          countryCode: address.countryCode,
          line1: address.line1,
          line2: address.line2,
          postalCode: address.postalCode,
          state: address.state
        },
        dropOffLocation: {
          latitude: addressGeocodeData.latitude,
          longitude: addressGeocodeData.longitude
        },
        menuType
      };

      const deliveryTime = delivery.returnValidDeliveryTime(options.deliveryTime);

      if (deliveryTime) {
        body.deliveryTime = deliveryTime;
      }

      else {
        const pickupAsapTimestamp = await pickupTimes.getAsapTimestamp({
          location,
          menuType,
          merchant,
          order
        });

        body.pickupTime = pickupAsapTimestamp;
      }

      const response = await http.post('/cardfree-api/v1/account/me/delivery/estimate', body);

      return delivery.parseEstimateResponse(options, response.data, body.deliveryService);
    }

    catch (error) {
      errorHandlers.silent(error);

      throw new Error('Delivery is not available.');
    }
  },

  parseEstimateResponse(options, data, service) {
    const currentTime = moment().tz(options.location.timeZone);
    const deliveryTime = moment(data.deliveryTime).tz(options.location.timeZone);
    const etaInMinutes = deliveryTime.diff(currentTime, 'minutes');
    let etaDisplay = `${etaInMinutes}–${etaInMinutes + 10} mins`;

    if (etaInMinutes > 90) {
      etaDisplay = deliveryTime.calendar(null, {
        sameDay: '[Today @] h:mm A',
        nextDay: '[Tomorrow @] h:mm A',
        nextWeek: 'ddd [@] h:mm A',
        sameElse: 'M/D [@] h:mm A'
      });
    }

    return {
      etaDisplay,
      deliveryService: service,
      deliveryServiceCharge: data.deliveryServiceCharge,
      deliveryTime: data.deliveryTime,
      fee: data.fee,
      deliveryTimeOffset: data.deliveryTimeOffset,
      pickupTime: data.pickupTime
    };
  },

  returnValidDeliveryTime(deliveryTime) {
    const time = moment(deliveryTime);
    const now = moment();

    /*
      NOTE: If our selected delivery time is not at least a few seconds in the future,
      DoorDash will return an error. Otherwise, DoorDash is able to give us the soonest
      available time without erroring. If our selected time is not far enough in the future,
      we'll return `null`, which will fallback to our logic to fetch the soonest pickup
      time from our location.
    */

    if (time.diff(now, 'seconds') >= 60) {
      return deliveryTime;
    }

    return null;
  }
};



export default delivery;
